export default __webpack_public_path__ + "static/college-audition-guide-preview-2-03547f52f8b6da1937ea740184e24eed.jpg";